export const localizedBbqEvent = (event, lang) => event && ({
  ...event,
  ...Object.fromEntries(Object.entries(event.translations || {}).map(([key, values]) => [key, values[lang] || event[key]])),
});